import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '@base/base.service';
import { Dimension, DimensionRenameResult, DimensionRenameScan, DimensionUsage } from '../models/dimension.model';

@Injectable()
export class DimensionsService extends BaseService<Dimension> {
  serviceUrl = '/api/dimensions';

  usage(): Observable<{ rows: DimensionUsage[] }> {
    return this.http.get<{ rows: DimensionUsage[] }>(`${this.serviceUrl}/usage`);
  }

  /** Registers every dimension currently in use on a question. Idempotent. */
  seed(): Observable<{ created: string[] }> {
    return this.http.post<{ created: string[] }>(`${this.serviceUrl}/seed`, {});
  }

  /** Dry run: what a rename would touch on the questions and in each result store. */
  renameScan(from: string, to: string): Observable<DimensionRenameScan> {
    return this.http.post<DimensionRenameScan>(`${this.serviceUrl}/rename/scan`, { from, to });
  }

  /**
   * Renames the dimension on its record, on every question using it, and on
   * the stored answers in the stores the caller opted into.
   */
  rename(
    from: string,
    to: string,
    options: { migrateElastic?: boolean; migratePrivate?: boolean } = {}
  ): Observable<DimensionRenameResult> {
    return this.http.post<DimensionRenameResult>(`${this.serviceUrl}/rename`, {
      from,
      to,
      migrateElastic: !!options.migrateElastic,
      migratePrivate: !!options.migratePrivate,
    });
  }
}
